export default function Pagination({ page, pageSize, total, onChange, testId = "pg" }) {
  const pages = Math.max(1, Math.ceil((total || 0) / pageSize));
  if (pages <= 1) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div
      data-testid={`pagination-${testId}`}
      style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginTop: 16, flexWrap: "wrap" }}
    >
      <span className="text-muted" style={{ fontSize: 13 }}>
        {from}–{to} de {total}
      </span>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <button
          className="btn-mini"
          data-testid={`pagination-${testId}-prev`}
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
        >
          <i className="fas fa-chevron-left" /> Anterior
        </button>
        <span style={{ fontSize: 13 }} data-testid={`pagination-${testId}-status`}>
          Página {page} de {pages}
        </span>
        <button
          className="btn-mini"
          data-testid={`pagination-${testId}-next`}
          disabled={page >= pages}
          onClick={() => onChange(page + 1)}
        >
          Siguiente <i className="fas fa-chevron-right" />
        </button>
      </div>
    </div>
  );
}
